cb.define(['common/common_VM.Extend.js'], function (common) {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };

    var proMap = {};
    var skuMap = {};
    const returnSkuId = "productskus_id";
    const returnSkuCode = "code";
    const returnSkuName = "name";
    const returnSkuSpec = "specs";
    const returnProId = "id";
    const returnProCode = "code";
    const returnProName = "cName";
    var PM_pmc_increasepurchase_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            var self = this;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            var mode = viewmodel.getParams().mode;
            var unit = cb.rest.AppContext.user.currencyName || "元";

          viewmodel.get('cMonthDays').setState('min', 1);
          viewmodel.get('cMonthDays').setState('max', 31);

            viewmodel.get("giftPreferentialStrategy").setState('defaultSelectedRowIndexes', true);
            viewmodel.get("giftPreferentialStrategy").setState('showRowNo',false);

            const displayReferType = (viewmodel, value) => {
                var refCode = "";
                var refRetId = "";
                //1商品分类 2 商品模板 3 商品品牌 4 商品标签
                if (value == 1) {
                    refCode = "pc_presentationclassref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 2) {
                    refCode = "pc_producttplref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 3) {
                    refCode = "pc_brandref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                } else if (value == 4) {
                    refCode = "pc_tagref";
                    refRetId = '{"iReferenceId":"id","iReferenceName":"name"}';
                }
                if (refCode) {
                    viewmodel.get("giftPreferentialClassPro").setRefCode(refCode, refRetId);
                }
            }

          const displayActivityMode = (applicableChannel) => {
              var visibleFlag = false;
              if (applicableChannel){
                if (applicableChannel.indexOf("1") > -1){
                  viewmodel.get('activityMode').setVisible(true);
                  visibleFlag = true;
                }else {
                  viewmodel.get('activityMode').setVisible(false);
                }
              }else{
                viewmodel.get('activityMode').setVisible(false);
              }
            displayActivityModeDetail(visibleFlag);
          }

          const displayActivityModeDetail = (visibleFlag) => {
              if (visibleFlag){
                common.displayActivityMode(viewmodel);
              }else{
                viewmodel.get('beginTime').setVisible(false);
                viewmodel.get('endTime').setVisible(false);
                viewmodel.get('cWeekDays').setVisible(false);
                viewmodel.get('cWeekBeginTime').setVisible(false);
                viewmodel.get('cWeekEndTime').setVisible(false);
                viewmodel.get('cMonthDays').setVisible(false);
                viewmodel.get('cMonthBeginTime').setVisible(false);
                viewmodel.get('cMonthEndTime').setVisible(false);
              }
          }

            const displayiActivityItemType = (viewmodel) => {
                if (viewmodel.get('iActivityItemType').getValue() == 0) {
                    viewmodel.get('giftPreferentialClassPro').setVisible(false);
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: true
                    });
                    if (mode != 'browse') {
                        viewmodel.get('btnAddRow').setVisible(true);
                        viewmodel.get('btnBatchOp').setVisible(true);
                    }
                } else {
                    viewmodel.get('giftPreferentialClassPro').setVisible(true);
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                }
            }

            const displayisAllProduct = (viewmodel) => {
                if (viewmodel.get('isAllProduct').getValue() == 1) {
                    viewmodel.get('iActivityItemType').setValue(0);
                    viewmodel.get('iActivityItemType').setVisible(false);

                    displayiActivityItemType(viewmodel);

                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });

                } else {
                    viewmodel.get('iActivityItemType').setVisible(true);
                    displayiActivityItemType(viewmodel);
                }
            }

            const displayisShare = () => {
                let isShare = viewmodel.get('isShare').getValue();
                if (isShare == 0) {
                    viewmodel.get('isTakeInShare').setDisabled(true);
                    viewmodel.get('isTakeInShare').setValue(0);
                } else {
                    viewmodel.get('isTakeInShare').setDisabled(false);
                }
            }

            const delPro = () => {
                if (viewmodel.get('giftPreferentialPro').getRows() && viewmodel.get('giftPreferentialPro').getRows().length > 0) {
                    let pricenums = viewmodel.get('giftPreferentialPro').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('giftPreferentialPro').deleteRows(i);
                    }
                }
            }

            const delClassPro = () => {
                if (viewmodel.get('giftPreferentialClassPro').getShowValue() && viewmodel.get('giftPreferentialClassPro').getShowValue().length > 0) {
                    viewmodel.get('giftPreferentialClassPro').setValue([]);
                }
            }

            const displayisSpreadCode = () => {
                if (viewmodel.get("isSpreadCode").getValue() && viewmodel.get("isSpreadCode").getValue() == 1) {
                    viewmodel.get('giftPreferentialSpread').setVisible(true);
                } else {
                    viewmodel.get('giftPreferentialSpread').setVisible(false);
                }
            }

            const displayStrategy = (editRowModel, editRowModels) => {
                /**InputNumber不为负数**/
                editRowModel.get('dConsumerSpending').setState('min', 0);
                editRowModel.get("giftPreferentialItem").getEditRowModel().get('iConsumerSpending').setState('min', 0);
                editRowModel.get("giftPreferentialItem").getEditRowModel().get('iGiftNum').setState('min', 0);
                editRowModel.get("giftPreferentialItem").getEditRowModel().get('iFarePrice').setState('min', 0);
                editRowModel.get('giftPreferentialItem').setState('showColumnSetting', false);

                let iGiftType = viewmodel.get("iGiftType").getValue();
                editRowModel.get('dConsumerSpending').setState("after", iGiftType == 1 ? unit : "件");

                editRowModel.get('giftPreferentialItem').on('beforeInsertRowsFromRefer', function (data) {
                    let newData;
                    if (data.columnName == 'sgiftnames') {
                        newData = proMap[data.index];
                    } else {
                        newData = skuMap[data.index];
                    }
                    var row = {};
                    if (newData) {
                        let nameKey = data.columnName;
                        let idKey = "sgiftids";
                        let codeKey = "sgiftcodes";
                        let describe = "skuDescribe";
                        let returnIdKey = returnProId;
                        let returnCodeKey = returnProCode;
                        let returnNameKey = returnProName;
                        let returnDecKey = returnSkuSpec;
                        //商品
                        if (data.columnName == 'sgiftnames') {
                        } else {
                            idKey = "sGiftSkuIds";
                            codeKey = "sGiftSkuCodes";
                            returnNameKey = returnSkuName;
                            returnIdKey = returnSkuId;
                        }
                        row[idKey] = "";
                        row[nameKey] = "";
                        row[codeKey] = "";
                        // row[productCode] = "";
                        // row[skuCode] = "";
                        for (let i = 0; i < newData.length; i++) {
                            if (newData[i][returnIdKey] && newData[i][returnIdKey] != "") {
                                row[idKey] += newData[i][returnIdKey];
                                if (i != newData.length - 1)
                                    row[idKey] += ",";
                            }
                            if (newData[i][returnNameKey] && newData[i][returnNameKey] != "") {
                                row[nameKey] += newData[i][returnNameKey];
                                if (newData[i][returnDecKey] && newData[i][returnDecKey] != "") {
                                    row[nameKey] += "(" + newData[i][returnDecKey] + ")";
                                }
                                if (i != newData.length - 1)
                                    row[nameKey] += ",";
                            }
                            if (newData[i][returnCodeKey] && newData[i][returnCodeKey] != "") {
                                row[codeKey] += newData[i][returnCodeKey];
                                if (i != newData.length - 1)
                                    row[codeKey] += ",";
                            }
                            // if (newData[i][skuCode] && newData[i][skuCode] != "") {
                            //     row[skuCode] += newData[i][skuCode];
                            //     if (i != newData.length - 1)
                            //         row[skuCode] += ",";
                            // }
                        }
                        data.rows.length = 0;
                        data.rows.push(row);
                    }
                })

                //  增行后事件
                // 增行时判断是否最后一组，最后一组增行时将是否倍增启用
                editRowModel.get('giftPreferentialItem').on('afterInsertRow', function (data) {
                    if (editRowModels.length == data.index + 1) {
                        let giftPreferentialItem = editRowModel.get('giftPreferentialItem').getData();
                        if (giftPreferentialItem && giftPreferentialItem.length > 0) {
                            editRowModel.get('giftPreferentialItem').setCellState(0, "icapping", "disabled", false);
                        }
                    }
                })

                editRowModel.get('giftPreferentialItem').on("beforeBrowse", function (data) {
                    let condition = {
                        "isExtend": true,
                        simpleVOs: []
                    };
                    let rowIndex = data.rowIndex;
                    let banProducts = "";
                    let banSkus = "";
                    let preferentialProList = editRowModel.get('giftPreferentialItem').getRows();
                    let currentPreferentialPro = preferentialProList[rowIndex].sgiftcodes;
                    let currentPreferentialProSku = preferentialProList[rowIndex].sGiftSkuCodes;
                    //sku参照
                    if (data && data.cellName == 'sGiftSkuNames') {
                        //当前行已经选了sku
                        if (currentPreferentialProSku && currentPreferentialProSku != '') {
                            condition.simpleVOs.push({
                                field: 'code',
                                op: 'in',
                                value1: currentPreferentialProSku.split(',')
                            });
                        } else {
                            // 排除当前行选择的商品的sku
                            if (currentPreferentialPro && currentPreferentialPro != '') {
                                banProducts += currentPreferentialPro;
                            }
                            //排除其他行选择的商品和sku
                            // for (let i = 0; i < preferentialProList.length; i++) {
                            //     if (i == rowIndex) {
                            //         continue;
                            //     }
                            //     //其他行选择了sku
                            //     if (preferentialProList[i].sGiftSkuCodes && preferentialProList[i].sGiftSkuCodes != '') {
                            //         if (banSkus != '' && i < preferentialProList.length - 1) {
                            //             banSkus += ",";
                            //             banSkus += preferentialProList[i].sGiftSkuCodes;
                            //         } else {
                            //             banSkus += preferentialProList[i].sGiftSkuCodes;
                            //         }
                            //     }
                            //     //其他行选择了商品
                            //     if (preferentialProList[i].sgiftcodes && preferentialProList[i].sgiftcodes != '') {
                            //         if (banProducts != '' && i < preferentialProList.length - 1) {
                            //             banProducts += ",";
                            //             banProducts += preferentialProList[i].sgiftcodes;
                            //         } else {
                            //             banProducts += preferentialProList[i].sgiftcodes;
                            //         }
                            //     }
                            // }
                        }
                        common.addProductReferCondition(viewmodel, true, condition, banProducts == "" ? null : banProducts.split(","),
                            banSkus == "" ? null : banSkus.split(","), false);
                    } else {
                        //商品参照
                        //当前行选了商品
                        if (currentPreferentialPro && currentPreferentialPro != '') {
                            condition.simpleVOs.push({
                                field: 'code',
                                op: 'in',
                                value1: currentPreferentialPro.split(',')
                            });
                        } else {
                            //排除当前行选择的sku
                            // if (currentPreferentialProSku && currentPreferentialProSku != '') {
                            //     banSkus += currentPreferentialProSku;
                            // }
                            //当前行没有选择商品，需要排除其他行选择的商品
                            // for (let i = 0; i < preferentialProList.length; i++) {
                            //     if (i == rowIndex) {
                            //         continue;
                            //     }
                            //     if (preferentialProList[i].sgiftcodes && preferentialProList[i].sgiftcodes != '') {
                            //         if (i > 0) {
                            //             banProducts += ",";
                            //             banProducts += preferentialProList[i].sgiftcodes;
                            //         } else {
                            //             banProducts += preferentialProList[i].sgiftcodes;
                            //         }
                            //     }
                            // }
                        }
                        common.addProductReferCondition(viewmodel, false, condition, banProducts == ""
                            ? null : banProducts.split(","), null, false);
                    }
                    data.context.setFilter(condition);
                    return true;
                })
                let giftPreferentialItem = editRowModel.get("giftPreferentialItem");
                let sGiftSkuNames = giftPreferentialItem.getEditRowModel().get('sGiftSkuNames');
                let sGiftNames = giftPreferentialItem.getEditRowModel().get('sgiftnames');
                sGiftSkuNames.on('afterBrowse', () => {
                    let vm = sGiftSkuNames.getCache('vm');
                    let refGridModel = vm.get('table');
                    refGridModel.setState('rowKeyField', 'productskus_id');
                    let preferentialProList = giftPreferentialItem.getRows();
                    var focusedRowIndex = giftPreferentialItem.getFocusedRowIndex();
                    var currentPreferentialPro = preferentialProList[focusedRowIndex];
                    var skuids = currentPreferentialPro.sGiftSkuIds ? currentPreferentialPro.sGiftSkuIds.split(',') : [];
                    var skucodes = currentPreferentialPro.sGiftSkuCodes ? currentPreferentialPro.sGiftSkuCodes.split(',') : [];
                    var skunames = currentPreferentialPro.sGiftSkuNames ? currentPreferentialPro.sGiftSkuNames.split(',') : [];
                    var pros = [];
                    for (let i = 0; i < skuids.length; i++) {
                        let newobj = {};
                        newobj[returnSkuId] = skuids[i];
                        newobj[returnSkuCode] = skucodes[i];
                        newobj[returnSkuName] = skunames[i];
                        pros.push(newobj);
                    }
                    skuMap[focusedRowIndex] = pros;
                    refGridModel.un('afterSetDataSource');
                    refGridModel.un('beforeUnselect');
                    refGridModel.un('beforeSelect');
                    refGridModel.un('beforeSelectAll');
                    refGridModel.un('beforeUnselectAll');
                    refGridModel.on('afterSetDataSource', data => {
                        let selectIndexes = [];
                        var focusedRowIndex = giftPreferentialItem.getFocusedRowIndex();
                        data.forEach((row, index) => {
                            let i = skuMap[focusedRowIndex].findIndex(item => {
                                return row.code == item.code;
                            });
                            if (i != -1) selectIndexes.push(index);
                        });
                        refGridModel.select(selectIndexes);
                        let condition = {
                            "isExtend": true,
                            simpleVOs: []
                        };
                        let rowIndex = focusedRowIndex;
                        let banProducts = "";
                        let banSkus = "";
                        let preferentialProList = editRowModel.get('giftPreferentialItem').getRows();
                        if (currentPreferentialPro.sgiftcodes && currentPreferentialPro.sgiftcodes != '') {
                            banProducts += currentPreferentialPro.sgiftcodes;
                        }
                        common.addProductReferCondition(viewmodel, true, condition, banProducts == "" ? null : banProducts.split(","),
                            banSkus == "" ? null : banSkus.split(","), false);
                        let params = vm.getParams();
                        if (params.where && params.where.filter)
                            vm.getParams().where.filter = condition;
                    });
                    refGridModel.on('beforeUnselect', indexes => {
                        cacheskuCodesMapFunction(refGridModel, focusedRowIndex, indexes, false);
                    });
                    refGridModel.on('beforeSelect', indexes => {
                        cacheskuCodesMapFunction(refGridModel, focusedRowIndex, indexes, true);
                    });
                    refGridModel.on('beforeSelectAll', args => {
                        cacheskuCodesMapFunction(refGridModel, focusedRowIndex, null, true, true);
                    });
                    refGridModel.on('beforeUnselectAll', args => {
                        cacheskuCodesMapFunction(refGridModel, focusedRowIndex, null, false, true);
                    });
                });
                sGiftNames.on('afterBrowse', () => {
                    let vm = sGiftNames.getCache('vm');
                    let refGridModel = vm.get('table');
                    let preferentialProList = giftPreferentialItem.getRows();
                    var focusedRowIndex = giftPreferentialItem.getFocusedRowIndex();

                    var currentPreferentialPro = preferentialProList[focusedRowIndex];
                    var proids = currentPreferentialPro.sgiftids ? currentPreferentialPro.sgiftids.split(',') : [];
                    var procodes = currentPreferentialPro.sgiftcodes ? currentPreferentialPro.sgiftcodes.split(',') : [];
                    var pronames = currentPreferentialPro.sgiftnames ? currentPreferentialPro.sgiftnames.split(',') : [];
                    var pros = [];
                    for (let i = 0; i < proids.length; i++) {
                        let newobj = {};
                        newobj[returnProId] = proids[i];
                        newobj[returnProCode] = procodes[i];
                        newobj[returnProName] = pronames[i];
                        pros.push(newobj);
                    }
                    proMap[focusedRowIndex] = pros;
                    refGridModel.un('afterSetDataSource');
                    refGridModel.un('beforeUnselect');
                    refGridModel.un('beforeSelect');
                    refGridModel.un('beforeSelectAll');
                    refGridModel.un('beforeUnselectAll');
                    refGridModel.on('afterSetDataSource', data => {
                        let selectIndexes = [];
                        var focusedRowIndex = giftPreferentialItem.getFocusedRowIndex();
                        data.forEach((row, index) => {
                            let i = proMap[focusedRowIndex].findIndex(item => {
                                return row.code == item.code;
                            });
                            if (i != -1) selectIndexes.push(index);
                        });
                        refGridModel.select(selectIndexes);
                        let condition = {
                            "isExtend": true,
                            simpleVOs: []
                        };
                        let rowIndex = focusedRowIndex;
                        let banProducts = "";
                        let banSkus = "";
                        // let preferentialProList = editRowModel.get('giftPreferentialItem').getRows();
                        // if (currentPreferentialPro.sgiftcodes && currentPreferentialPro.sgiftcodes != '') {
                        //     banProducts += currentPreferentialPro.sgiftcodes;
                        // }
                        common.addProductReferCondition(viewmodel, false, condition, banProducts == "" ? null : banProducts.split(","),
                            banSkus == "" ? null : banSkus.split(","), false);
                        let params = vm.getParams();
                        if (params.where && params.where.filter)
                            vm.getParams().where.filter = condition;
                    });
                    refGridModel.on('beforeUnselect', indexes => {
                        cacheProCodesMapFunction(refGridModel, focusedRowIndex, indexes, false);
                    });
                    refGridModel.on('beforeSelect', indexes => {
                        cacheProCodesMapFunction(refGridModel, focusedRowIndex, indexes, true);
                    });
                    refGridModel.on('beforeSelectAll', args => {
                        cacheProCodesMapFunction(refGridModel, focusedRowIndex, null, true, true);
                    });
                    refGridModel.on('beforeUnselectAll', args => {
                        cacheProCodesMapFunction(refGridModel, focusedRowIndex, null, false, true);
                    });
                });
                editRowModel.get("dConsumerSpending").on('afterValueChange', function (args) {
                    let dConsumerSpend = editRowModel.get('dConsumerSpending').getData();
                    editRowModel.get("giftPreferentialItem").setCellValue(0, 'iConsumerSpending', dConsumerSpend, true);
                })

                sGiftSkuNames.on('afterValueChange', () => {
                  editRowModel.get("giftPreferentialItem").setCellValue(0, 'sgiftnames', null, true);
                  editRowModel.get("giftPreferentialItem").setCellValue(0, 'sgiftcodes', null, true);
                });
                sGiftNames.on('afterValueChange', () => {
                  editRowModel.get("giftPreferentialItem").setCellValue(0, 'sGiftSkuNames', null, true);
                  editRowModel.get("giftPreferentialItem").setCellValue(0, 'sGiftSkuCodes', null, true);
                });
            }

            const cacheskuCodesMapFunction = function (refGridModel, index, rowIndexes, bSelect, bAll) {
                let rows = bAll ? refGridModel.getRows() : refGridModel.getRowsByIndexes(rowIndexes);
                let pros = skuMap[index] || [];
                rows.map(row => {
                    let i = pros.findIndex(pro => {
                        return pro.code == row.code;
                    });
                    if (bSelect) {
                        if (i == -1) pros.push(row);
                    } else {
                        if (i != -1) pros.splice(i, 1);
                    }
                })
                skuMap[index] = pros;
            }

            const cacheProCodesMapFunction = function (refGridModel, index, rowIndexes, bSelect, bAll) {
                let rows = bAll ? refGridModel.getRows() : refGridModel.getRowsByIndexes(rowIndexes);
                let pros = proMap[index] || [];
                rows.map(row => {
                    let i = pros.findIndex(pro => {
                        return pro.code == row.code;
                    });
                    if (bSelect) {
                        if (i == -1) pros.push(row);
                    } else {
                        if (i != -1) pros.splice(i, 1);
                    }
                })
                proMap[index] = pros;
            }

            const displayPrice = (viewmodel) => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "iProductId": "id", "sProductName": "cName", "sProductCode": "code", "fSalePrice": "fSalePrice",
                        "fMarkPrice": "fMarkPrice", "sProductPicUrl": "url", "cDescribe": "modelDescription"
                    }
                    let sku_refRetId = {
                        "iProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarkPrice": "fMarkPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    }
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                } else {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "iProductId": "id", "sProductName": "cName", "sProductCode": "code", "fSalePrice": "fSalePrice",
                        "fMarkPrice": "fMarketPrice", "sProductPicUrl": "url", "cDescribe": "modelDescription"
                    }
                    let sku_refRetId = {
                        "iProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "fSalePrice": "salePrice",
                        "fMarkPrice": "fMarketPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    }
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("giftPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                }
            }

            viewmodel.get("giftPreferentialPro").on("beforeBrowse", function (data) {
                common.productReferBrowseSimple(viewmodel, data, "iProductIdType", "giftPreferentialPro");
                return true;
            })

            //商品单元格改变后事件
            viewmodel.get('giftPreferentialPro').on('afterCellValueChange', function (data) {
                if (data.cellName === 'sProductCode') {
                    this.setCellValue(data.rowIndex, 'iProductIdType', 0);
                }
                if (data.cellName === 'sProductSkuCode') {
                    this.setCellValue(data.rowIndex, 'iProductIdType', 1);
                }
            })

            viewmodel.get('isShare').on("afterValueChange", function (data) {
                displayisShare();
            })

          //活动方式控制事件
          viewmodel.get('activityMode').on('afterValueChange', function (data) {
            common.displayActivityMode(viewmodel);
          });

            //商品单元格改变后事件
            viewmodel.get('iGiftType').on('afterValueChange', function (data) {
                let iGiftType = viewmodel.get("iGiftType").getValue();
                let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                if (editRowModels && editRowModels.length > 0) {
                    for (let i = 0; i < editRowModels.length; i++) {
                        editRowModels[i].get('dConsumerSpending').setState("after", iGiftType == 1 ? unit : "件");
                    }
                }
            })

            viewmodel.get("giftPreferentialStrategy").on('afterSetDataSource', function (args) {
                let params = viewmodel.getParams()
                if (params.mode == "browse")
                    common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
            });
            // viewmodel.get("giftPreferentialStrategy").on('afterSetDataSource', function (args) {
            //     let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
            //     for (let i = 0; i < args.length; i++) {
            //         if (i > 0) {
            //             //将上一组倍增置为不倍增，禁用
            //             let lastRowModel = editRowModels[i - 1];
            //             let giftPreferentialItemList = lastRowModel.get('giftPreferentialItem').getRows();
            //             if (giftPreferentialItemList && giftPreferentialItemList.length > 0) {
            //                 //加价购组只有一行
            //                 lastRowModel.get('giftPreferentialItem').setCellValue(0, "icapping", 0);
            //                 lastRowModel.get('giftPreferentialItem').setCellState(0, "icapping", 'disabled', true);
            //             }
            //         }
            //         displayStrategy(editRowModels[i], editRowModels);
            //     }
            // });
            viewmodel.get("giftPreferentialStrategy").on('afterInsertRow', function (args) {
                let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                let editRowModel = editRowModels[args.index];
                //加价购只有最后一组数据才启用倍增
                if (editRowModels.length > 1 && args.index > 0) {
                    //将上一组倍增置为不倍增，禁用
                    let lastRowModel = editRowModels[args.index - 1];
                    let giftPreferentialItemList = lastRowModel.get('giftPreferentialItem').getRows();
                    if (giftPreferentialItemList && giftPreferentialItemList.length > 0) {
                        //加价购组只有一行
                        lastRowModel.get('giftPreferentialItem').setCellValue(0, "icapping", 0, true);
                        lastRowModel.get('giftPreferentialItem').setCellState(0, "icapping", 'disabled', true);
                    }
                }
                displayStrategy(editRowModel, editRowModels);
            });

            viewmodel.get("isSpreadCode").on("afterValueChange", function (data) {
                displayisSpreadCode();
            })

            viewmodel.on('beforeDeleteRow', function (args) {
                let giftPreferentialStrategy = viewmodel.get('giftPreferentialStrategy').getData();
                if (giftPreferentialStrategy && giftPreferentialStrategy.length == 1 && args.params.params.cItemName == 'btnDeleteRow3') {
                    cb.utils.alert("只有一个分组无法删除");
                    return false;
                }
            });
            //加价购每组只能增加一行
            viewmodel.on('beforeAddRow', function (data) {
                if (data.params.cItemName == "btnAddRow2") {
                    let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                    let giftPreferentialItem = editRowModels[data.params.params.index].get('giftPreferentialItem').getRows();
                    if (giftPreferentialItem && giftPreferentialItem.length > 0) {
                        cb.utils.alert("只能增加一行");
                        return false;
                    }
                }
            })
            //策略组删除后事件
            viewmodel.get("giftPreferentialStrategy").on('afterDeleteRows', function (args) {
                let giftPreferentialStrategy = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                for (let i = 0; i < giftPreferentialStrategy.length; i++) {
                    let item = giftPreferentialStrategy[i].get("giftPreferentialItem");
                    if (i == giftPreferentialStrategy.length - 1) {
                        if (item && item.getRows().length > 0) {
                            item.setCellValue(0, "icapping", 0, true);
                            item.setCellState(0, "icapping", "disabled", false);
                        }
                    } else {
                        if (item && item.getRows().length > 0) {
                            item.setCellValue(0, "icapping", 0, true);
                            item.setCellState(0, "icapping", "disabled", true);
                        }
                    }
                }
            });
            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('giftPreferentialPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("giftPreferentialPro").deleteRows(rowIndexes);
            })

            viewmodel.on("modeChange", function (data) {
                mode = data;
                if (data == "browse") {
                    common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
                } else {
                    let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                    for (let i = 0; i < editRowModels.length; i++) {
                        editRowModels[i].get('btnAddRow2').setVisible(true);
                        editRowModels[i].get('btnAddRow3').setVisible(true);
                        editRowModels[i].get('btnDeleteRow3').setVisible(true);
                        let grandsonModel = editRowModels[i].get('giftPreferentialItem');
                        let data = grandsonModel.getData();
                        if (data.length > 0) {
                            let actionsState = [];
                            data.forEach((row, index) => {
                                actionsState.push({
                                    'btnDeleteRow2': {'visible': true}
                                })
                            })
                            grandsonModel.setActionsState(actionsState);
                        }
                    }
                    common.displayChannel(viewmodel, 'increasepurchase');
                }
            })

            viewmodel.on('beforeEdit', function (data) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_increasepurchase');
            })

            viewmodel.on('afterMovenext', function (data) {
                common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
            })

            viewmodel.on('afterMoveprev', function (data) {
                common.displayGrandsonBtn(viewmodel, 'giftPreferentialStrategy', 'giftPreferentialItem');
            })

            viewmodel.on('afterEdit', function (data) {
                displayisAllProduct(viewmodel);
            })

            viewmodel.on('afterLoadData', function (data) {
                displayisShare();
                displayPrice(viewmodel);
                common.displayChannel(viewmodel);
                common.displayActivityMode(viewmodel);
                common.hideNoStore(viewmodel);
                if (mode === 'add') {
                    viewmodel.get('iGiftType').setValue(1);
                    viewmodel.get('giftPreferentialStrategy').appendRow({});
                } else if (mode === 'edit' || mode === 'browse') {
                    let editRowModels = viewmodel.get('giftPreferentialStrategy').getCache('editRowModels');
                    for (let i = 0; i < editRowModels.length; i++) {
                        if (i > 0) {
                            //将上一组倍增置为不倍增，禁用
                            let lastRowModel = editRowModels[i - 1];
                            let giftPreferentialItemList = lastRowModel.get('giftPreferentialItem').getRows();
                            if (giftPreferentialItemList && giftPreferentialItemList.length > 0) {
                                //加价购组只有一行
                                // lastRowModel.get('giftPreferentialItem').setCellValue(0, "icapping", 0, true);
                                lastRowModel.get('giftPreferentialItem').setCellState(0, "icapping", 'disabled', true);
                            }
                        }
                        displayStrategy(editRowModels[i], editRowModels);
                    }
                }

                // viewmodel.get('btnAddRow3').setVisible(false);

                displayisAllProduct(viewmodel);
                displayisSpreadCode();
                displayReferType(viewmodel, viewmodel.get("iActivityItemType").getValue());

                if (this.get('isAllMemberLeve').getValue() == 0) {
                    viewmodel.get('giftPreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('giftPreferentialMemberL').setVisible(false);
                }

                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["1"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('applicableChannel').setValue(["0"]);
                    //只适用线上商城时，不展示活动方式等相关字段
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                }

                if (this.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('giftPreferentialStore').setVisible(false);
                    viewmodel.get('offLineStore').setValue(1);
                    viewmodel.get('isShare').setVisible(false);
                    viewmodel.get('isTakeInShare').setVisible(false);
                } else {
                    viewmodel.get('iSendPoint').setVisible(true);
                    viewmodel.get('offLineStore').setVisible(true);
                    viewmodel.get('isShare').setVisible(true);
                    viewmodel.get('isTakeInShare').setVisible(true);
                    if (viewmodel.get('offLineStore').getValue() == 1) {
                        viewmodel.get('giftPreferentialStore').setVisible(false);
                    } else {
                        viewmodel.get('giftPreferentialStore').setVisible(true);
                    }
                    //仅勾线下
                    if (this.get('applyOnlineChannel').getValue() == 0) {
                        viewmodel.get('iSendPoint').setVisible(true);
                    } else {
                        viewmodel.get('iSendPoint').setVisible(false);
                    }
                }
                if (this.get('applyOnlineChannel').getValue() == 0) {
                    viewmodel.get('terminalType').setVisible(false);
                } else {
                    viewmodel.get('terminalType').setVisible(true);
                }
                displayActivityMode(viewmodel.get('applicableChannel').getValue());
            });

            viewmodel.get('isAllMemberLeve').on('afterValueChange', function (data) {
                if (data.value.value == 0) {
                    viewmodel.get('giftPreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('giftPreferentialMemberL').setVisible(false);
                }
            });

            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('isShare').setVisible(false);
                viewmodel.get('isTakeInShare').setVisible(false);
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('giftPreferentialStore').setVisible(false);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get('applyOffLineChannel').setValue(false);
                viewmodel.get('iSendPoint').setVisible(false);
                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                    } else if (data.value[i].value == 1) {
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        viewmodel.get('isShare').setVisible(true);
                        viewmodel.get('isTakeInShare').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('giftPreferentialStore').setVisible(false);
                        } else {
                            viewmodel.get('giftPreferentialStore').setVisible(true);
                        }
                    }
                }
                //仅勾线下
                if (data.value.length == 1 && data.value[0].value == 1) {
                    viewmodel.get('iSendPoint').setVisible(true);
                }
                displayPrice(viewmodel);
                displayActivityMode(viewmodel.get('applicableChannel').getValue());
            });
            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value == 1) {
                    viewmodel.get('giftPreferentialStore').setVisible(false);
                } else {
                    viewmodel.get('giftPreferentialStore').setVisible(true);
                }
            });

            viewmodel.get('isAllProduct').on('afterValueChange', function (data) {
                delPro();
                delClassPro();
                displayisAllProduct(viewmodel);
            })

            viewmodel.get("iActivityItemType").on('afterValueChange', function (args) {
                delPro();
                delClassPro();
                displayiActivityItemType(viewmodel);
                displayReferType(viewmodel, args.value.value);
            })

            viewmodel.get("giftPreferentialItem").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sgiftnames') {
                    this.setCellValue(args.rowIndex, 'sGiftSkuNames', null, true);
                } else if (args.cellName == 'sGiftSkuNames') {
                    this.setCellValue(args.rowIndex, 'sgiftnames', null, true);
                }
            })

            viewmodel.get("giftPreferentialClassPro").on('beforeInsertRowsFromRefer', function (args) {
                for (var i = 0; i < args.rows.length; i++) {
                    args.rows[i]['iReferType'] = viewmodel.get("iActivityItemType").getValue() - 1;
                }
            });

            viewmodel.get("giftPreferentialPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 0);
                    this.setCellValue(args.rowIndex, 'sProductSkuName', null);
                    this.setCellValue(args.rowIndex, 'sProductSkuCode', null);
                }
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'iProductIdType', 1);
                }
            })


            viewmodel.on('statictempexport', function (params) {
                const openUrl = params && params.cSvcUrl;
                if (!openUrl) {
                    cb.utils.alert('导出模板的地址为空', 'error');
                    return;
                }
                window.open(openUrl);
            });

            viewmodel.on('batchimport', function (params) {
                const url = `${params.cSvcUrl}?token=${cb.rest.AppContext.token}&billnum=pmc_seckill`;
                const eleInput = document.createElement('input');
                eleInput.type = 'file';
                eleInput.style.display = 'none';
                eleInput.onchange = function (e) {
                    const formData = new FormData();
                    formData['enctype'] = 'multipart/form-data';
                    formData.append('file', e.target.files[0]);

                    var param = {};
                    param.type = 3;
                    param.applyOnlineChannel = viewmodel.get('applyOnlineChannel').getValue();
                    param.applyOffLineChannel = viewmodel.get('applyOffLineChannel').getValue();
                    formData.append('data', JSON.stringify(param));

                    cb.utils.alert(`导入中，请稍后`, 'info');

                    const xhr = new XMLHttpRequest();
                    xhr.open('POST', url, true);
                    xhr.send(formData);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState !== 4) return;
                        if (xhr.status === 200) {
                            var ajaxResult = JSON.parse(xhr.responseText);
                            if (ajaxResult.code === 200) {
                                if (ajaxResult.data.code === 200) {
                                    var array = [];
                                    var res = ajaxResult.data.data;
                                    var gridModel = viewmodel.get("giftPreferentialPro");
                                    for (let i = 0; i < res.data.length; i++) {
                                        var appendData = {};
                                        var data = res.data[i];
                                        appendData.iProductIdType = data.iProductIdType;
                                        if (appendData.iProductIdType == 0) {
                                            appendData.sProductCode = data.cCode;
                                            appendData.sProductName = data.sProductName;
                                        } else {
                                            appendData.sProductCode = data.productCode;
                                            appendData.sProductName = data.productName;
                                            appendData.sProductSkuCode = data.cCode;
                                            appendData.sProductSkuName = data.sProductName;
                                        }
                                        appendData.fMarkPrice = data.fMarkPrice;
                                        appendData.fSalePrice = data.fSalePrice;
                                        appendData.iProductId = data.iProductId;
                                        appendData.sProductPicUrl = data.sProductPicUrl;
                                        array.push(appendData);
                                        // gridModel.appendRow(appendData);
                                    }
                                    let count = gridModel.getRowsCount();
                                    var indexes = [];
                                    for (let i = count - 1; i >= 0; i--) {
                                        indexes.push(i);
                                    }
                                    gridModel.deleteRows(indexes);
                                    gridModel.insertRows(0, array);
                                    var errorMessages = '';
                                    if (res.errorCount) {
                                        for (let i = 0; i < res.allMsgs.length; i++) {
                                            if (res.allMsgs[i].isError) {
                                                errorMessages += res.allMsgs[i].msg;
                                            }
                                        }
                                    }
                                    cb.utils.alert(`共导入${res.totalCount}条, 成功${res.successCount}条, 失败${res.errorCount}条${res.errorCount ? `失败原因是: ${res.errorMsgs + errorMessages}` : ''}`, res.errorCount ? 'error' : 'success');
                                } else {
                                    cb.utils.alert(`${ajaxResult.data.message}，模板内容导入失败`, 'error');
                                }
                            } else {
                                cb.utils.alert(`${ajaxResult.message}，模板内容导入失败`, 'error');
                            }
                        }
                    };
                    document.body.removeChild(eleInput);
                };
                document.body.appendChild(eleInput);
                eleInput.click();
            });

            viewmodel.on('beforeSave', function (data) {
                var obj = JSON.parse(data.data.data);

                obj.iMutexType = 0;
                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                // obj.isTakeInShare = setCheckBoxEnum(obj.isTakeInShare);

              obj.cMonthDays = String(obj.cMonthDays);

              if (this.get('cMonthDays').getValue() && this.get('cMonthDays').getValue() != '') {
                obj.cMonthDays = ',' + obj.cMonthDays + ',';
              }

              if (this.get('cWeekDays').getValue() && this.get('cWeekDays').getValue() != '') {
                obj.cWeekDays = ',' + obj.cWeekDays + ',';
              }

              if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }

                if (this.get('isAllMemberLeve').getValue() == '0' && this.get('giftPreferentialMemberL').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('isAllMemberLeve').getValue() != '0') {
                    obj.giftPreferentialMemberL = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('giftPreferentialStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (obj.isAllMemberLeve == 1) {
                        obj.isAllMemberLeve = 2;
                    }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.giftPreferentialStore = [];
                }

                // if (mode == 'add') {
                //     if (viewmodel.get('dStartDate').getValue() <= nowDates.format('yyyy-MM-dd hh:mm:ss')) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }

                if (viewmodel.get('dStartDate').getValue() >= viewmodel.get('dEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                var activityModeValidNotCheck = this.get('applyOnlineChannel').getValue() == '1' && this.get('applyOffLineChannel').getValue() == '0'

                if (!activityModeValidNotCheck){
                  //每天、每周、每月活动时间控制
                  if (this.get('activityMode').getValue() == 1) {
                    if (!this.get('beginTime').getValue() || !this.get('endTime').getValue()) {
                      cb.utils.alert('每天活动时间不能为空', 'warning');
                      return false;
                    }
                    if (this.get('beginTime').getValue() >= this.get('endTime').getValue()) {
                      cb.utils.alert('每天活动开始时间必须小于结束时间', 'warning');
                      return false;
                    }
                  } else if (this.get('activityMode').getValue() == 2) {
                    if (!this.get('cWeekBeginTime').getValue() || !this.get('cWeekEndTime').getValue() || !this.get('cWeekDays').getValue()) {
                      cb.utils.alert('每周活动时间不能为空', 'warning');
                      return false;
                    }
                    if (this.get('cWeekBeginTime').getValue() >= this.get('cWeekEndTime').getValue()) {
                      cb.utils.alert('每周活动开始时间必须小于结束时间', 'warning');
                      return false;
                    }
                  } else if (this.get('activityMode').getValue() == 3) {
                    if (!this.get('cMonthDays').getValue() || !this.get('cMonthBeginTime').getValue() || !this.get('cMonthEndTime').getValue()) {
                      cb.utils.alert('每月活动时间不能为空', 'warning');
                      return false;
                    }
                    if (this.get('cMonthBeginTime').getValue() >= this.get('cMonthEndTime').getValue()) {
                      cb.utils.alert('每月活动开始时间必须小于结束时间', 'warning');
                      return false;
                    }
                  }
                }


                if (this.get('isAllProduct').getValue() == 0) {

                    if (viewmodel.get("iActivityItemType").getValue() == 0) {
                        if (!viewmodel.get('giftPreferentialPro').getRows() || viewmodel.get('giftPreferentialPro').getRows().length < 1) {
                            cb.utils.alert('请选择适用商品', 'warning');
                            return false;
                        } else {
                            for (let i = 0; i < viewmodel.get('giftPreferentialPro').getRows().length; i++) {
                                if (!viewmodel.get('giftPreferentialPro').getRows()[i].iProductId) {
                                    cb.utils.alert('请选择第' + (i + 1) + '行适用商品', 'warning');
                                    return false;
                                }
                            }
                        }
                    } else {
                        if (!viewmodel.get('giftPreferentialClassPro').getShowValue() || viewmodel.get('giftPreferentialClassPro').getShowValue().length < 1) {
                            cb.utils.alert('请选择适用商品类型', 'warning');
                            return false;
                        } else {
                            if (obj.giftPreferentialClassPro) {
                                for (let i = 0; i < obj.giftPreferentialClassPro.length; i++) {
                                    let classPro = obj.giftPreferentialClassPro[i];
                                    classPro.iReferType = viewmodel.get("iActivityItemType").getValue() - 1;
                                }
                            }
                        }
                    }
                }

                if (this.get('iGiftType')) {
                    if (viewmodel.get('giftPreferentialStrategy').getRows()) {
                        let dConsumerSpending;//比较分组的满足条件  后组的满额/满件条件必须大于前组满额/满件条件
                        for (let i = 0; i < viewmodel.get('giftPreferentialStrategy').getRows().length; i++) {
                            let strategy = viewmodel.get('giftPreferentialStrategy').getRows()[i];
                            if (!strategy.dConsumerSpending || strategy.dConsumerSpending <= 0) {
                                cb.utils.alert('请输入第' + (i + 1) + '组的满' + (this.get('iGiftType').getValue() == 1 ? '额' : '件') + '条件', 'warning');
                                return false;
                            } else {
                                if (i == 0) {
                                    dConsumerSpending = strategy.dConsumerSpending;
                                } else {
                                    if (dConsumerSpending >= strategy.dConsumerSpending) {
                                        cb.utils.alert('第' + (i + 1) + '组的满' + (this.get('iGiftType').getValue() == 1 ? '额' : '件') + '条件必须大于第' + i + '组的满'
                                            + (this.get('iGiftType').getValue() == 1 ? '额' : '件') + '条件', 'warning');
                                        return false;
                                    } else {
                                        dConsumerSpending = strategy.dConsumerSpending;
                                    }
                                }
                            }
                            let itemCount = 0;
                            if (!strategy.giftPreferentialItem || strategy.giftPreferentialItem.length == 0) {
                                cb.utils.alert('请输入第' + (i + 1) + '组的赠品信息', 'warning');
                                return false;
                            } else {
                                for (let j = 0; j < strategy.giftPreferentialItem.length; j++) {
                                    let item = strategy.giftPreferentialItem[j];
                                    if (item._status != 'Delete') {
                                        itemCount++;
                                        if (!item.iGiftNum || item.iGiftNum <= 0) {
                                            cb.utils.alert('请输入第' + (i + 1) + '组的赠品信息第' + itemCount + "行的赠送数量", 'warning');
                                            return false;
                                        }
                                        if ((!item.sgiftids || item.sgiftids == '') && (!item.sGiftSkuIds || item.sGiftSkuIds == '')) {
                                            cb.utils.alert('请选择第' + (i + 1) + '组的赠品信息第' + itemCount + "行的赠品", 'warning');
                                            return false;
                                        }
                                    }
                                }
                            }
                            if (itemCount == 0) {
                                cb.utils.alert('请输入第' + (i + 1) + '组的赠品信息', 'warning');
                                return false;
                            }
                        }
                    }
                    if (obj && obj.giftPreferentialPro) {
                        common.checkDefaultValue(obj.giftPreferentialPro, 'fMarkPrice', 'fSalePrice');
                    }
                    if (obj && obj.giftPreferentialExceptionPro) {
                        common.checkDefaultValue(obj.giftPreferentialExceptionPro, 'fMarkPrice', 'fSalePrice');
                    }
                    if (obj && obj.giftPreferentialStrategy) {
                        for (let i = 0; i < obj.giftPreferentialStrategy.length; i++) {
                            let strategy = obj.giftPreferentialStrategy[i];
                            if (strategy.giftPreferentialItem) {
                                for (let j = 0; j < strategy.giftPreferentialItem.length; j++) {
                                    let item = strategy.giftPreferentialItem[j];
                                    if (strategy._status == "Update" && item._status == "Unchanged") {
                                        item._status = "Update";
                                    }
                                    item.iConsumerSpending = strategy.dConsumerSpending;
                                    item.iGiftItemType = 1;
                                    if (item.sgiftids) {
                                        item.giftPreferentialItemPro = [];
                                        let sGiftIdsStr = item.sgiftids + '';
                                        let ids = sGiftIdsStr.split(',');
                                        for (let k = 0; k < ids.length; k++) {
                                            let itemPro = {"iProductId": null, "iProductIdType": 0};
                                            itemPro['iProductId'] = ids[k];
                                            item.giftPreferentialItemPro.push(itemPro);
                                        }
                                    }
                                    if (item.sGiftSkuIds) {
                                        if (!item.giftPreferentialItemPro) {
                                            item.giftPreferentialItemPro = [];
                                        }
                                        let sGiftSkuIdsStr = item.sGiftSkuIds + '';
                                        let ids = sGiftSkuIdsStr.split(',');
                                        for (let k = 0; k < ids.length; k++) {
                                            let itemPro = {"iProductId": null, "iProductIdType": 1};
                                            itemPro['iProductId'] = ids[k];
                                            item.giftPreferentialItemPro.push(itemPro);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                data.data.data = JSON.stringify(obj);
            })
        }
    };
    try {
        module.exports = PM_pmc_increasepurchase_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_increasepurchase_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_increasepurchase_VM.Extend.js